import { type ComponentProps, useContext } from "react"

import { CardImageFilesContext } from "./card-image-files-context"
import { InlineSessionImage } from "./inline-session-image"
import { isCardImageSrc } from "./inline-session-image-utils"

/** Inline markdown image that stays hidden when the message's image card already shows the file. */
export function CardAwareInlineImage({ src, ...rest }: ComponentProps<typeof InlineSessionImage>) {
  const { files, sessionId } = useContext(CardImageFilesContext)
  if (isCardImageSrc(src, files, sessionId)) return null
  return <InlineSessionImage src={src} {...rest} />
}
